import backurl from "@/router/module/backurl";
import get_title from "@/router/module/get_title";
import validate_role from "@/router/module/validate_role";

export default {
  path: "/reset-password",
  name: "ResetPassword",
  component: () => import("@/new/pages/reset-password.vue"),
  meta: {
    title: get_title("Создание пароля"),
    forVisitors: true,
    requiresAuth: false
  },
  beforeEnter: (to, from, next) => {
    const options = {
      route: { to, from, next },
      variant: "login",
      redirectText:
        "Вы уже авторизованы. Если вы хотите восстановить пароль, сначала выйдите из текущего аккаунта",
    };
    validate_role(options);
    if (router.history._startLocation === "/reset-password") {
      backurl(options, "/content/nomenclature");
    } else {
      backurl(options, router.history._startLocation);
    }
  }
};
